// The day a workout's swaps belong to: the client's own calendar day, starting at 3 am, so a session
// that runs past midnight keeps its swaps. Until 16 October 2026 swaps used the UTC date, which
// changes at 1 am in British summer time, and a late session lost its swaps part-way through (work
// list item 26).
const DAY_STARTS_AT_HOUR = 3;
const pad2 = (n) => String(n).padStart(2, '0');

export const trainingDay = (now = new Date()) => {
  const d = new Date(now.getTime() - DAY_STARTS_AT_HOUR * 60 * 60 * 1000);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};
